module.exports = __webpack_public_path__ + "static/img/5.7e76368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/5.png
// module id = N/sy
// module chunks = 1